"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

exports.__esModule = true;
exports.getRealHeight = exports.use100vh = void 0;

var react_1 = __importStar(require("react"));

function Div100vh(_a) {
  var _b = _a.style,
      style = _b === void 0 ? {} : _b,
      other = __rest(_a, ["style"]);

  var height = use100vh();

  var styleWithRealHeight = __assign(__assign({}, style), {
    height: height ? height + "px" : '100vh'
  });

  return react_1["default"].createElement("div", __assign({
    style: styleWithRealHeight
  }, other));
}

exports["default"] = Div100vh;

function use100vh() {
  var _a = react_1.useState(getRealHeight()),
      height = _a[0],
      setHeight = _a[1];

  var setRealHeight = function setRealHeight() {
    if (height !== getRealHeight()) setHeight(getRealHeight());
  };

  react_1.useEffect(function () {
    window.addEventListener('resize', setRealHeight);
    return function () {
      return window.removeEventListener('resize', setRealHeight);
    };
  }, [setRealHeight, height]);
  return height;
}

exports.use100vh = use100vh;

function getRealHeight() {
  var _a;

  if (typeof window === 'undefined') return null;
  return ((_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.clientHeight) || window.innerHeight;
}

exports.getRealHeight = getRealHeight;